/**
 * @generated SignedSource<<fb37ea17e4987eef4c974f2480f70e32>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanelItemModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarSoldItems_viewer" | "useShouldShowSimilarSoldItems_viewer" | "useSimilarSoldItemsTracking_viewer">;
  readonly " $fragmentType": "PdpRespAboutItemPanelItemModule_viewer";
};
export type PdpRespAboutItemPanelItemModule_viewer$key = {
  readonly " $data"?: PdpRespAboutItemPanelItemModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanelItemModule_viewer",
  "selections": [
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItems_viewer"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarSoldItemsTracking_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5fccc6f3eedd806155b103ca0af13df8";

export default node;
